const getTrackingCheckpointStyles = theme => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  flex: '0 1 auto',
  [theme.mediaQuery('tabletLarge')]: {
    flexDirection: 'row',
    flex: '1 1 auto'
  }
});
const getTrackingCheckpointSubtitleStyles = theme => ({
  color: theme.palette.gray.main
});
const getTrackingCheckpointDescriptionSubtitleStyles = theme => ({
  color: theme.palette.gray.main,
  fontStyle: 'italic'
});
const getTrackingCheckpointLabelStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
};
const getTrackingCheckpointTimeStyles = theme => ({
  marginTop: theme.spacing(),
  [theme.mediaQuery('tabletLarge')]: {
    textAlign: 'right',
    marginTop: 0,
    marginLeft: theme.spacing(2),
    flex: '0 0 auto'
  }
});

export { getTrackingCheckpointDescriptionSubtitleStyles, getTrackingCheckpointLabelStyles, getTrackingCheckpointStyles, getTrackingCheckpointSubtitleStyles, getTrackingCheckpointTimeStyles };
//# sourceMappingURL=TrackingCheckpointStyles.js.map
